export default __webpack_public_path__ + "static/media/car8.6c61da98.png";